var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAreaProdutoImobiliario(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_838_15293",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 21
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.350586,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_838_15293)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.16697 17.4338C3.82324 17.4338 3.52897 17.3114 3.28418 17.0667C3.03939 16.8219 2.91699 16.5276 2.91699 16.1839H4.16697V17.4338ZM2.91699 14.5172V12.8505H4.16697V14.5172H2.91699ZM2.91699 11.1839V9.51719H4.16697V11.1839H2.91699ZM2.91699 7.85053V6.18386H4.16697V7.85053H2.91699ZM2.91699 4.51719C2.91699 4.17346 3.03939 3.87919 3.28418 3.6344C3.52897 3.38961 3.82324 3.26721 4.16697 3.26721V4.51719H2.91699ZM5.83364 17.4338V16.1839H7.5003V17.4338H5.83364ZM5.83364 4.51719V3.26721H7.5003V4.51719H5.83364ZM9.16697 17.4338V16.1839H10.8336V17.4338H9.16697ZM9.16697 4.51719V3.26721H10.8336V4.51719H9.16697ZM12.5003 17.4338V16.1839H14.167V17.4338H12.5003ZM12.5003 4.51719V3.26721H14.167V4.51719H12.5003ZM15.8336 17.4338V16.1839H17.0836C17.0836 16.53 16.9612 16.8249 16.7164 17.0685C16.4716 17.312 16.1774 17.4338 15.8336 17.4338ZM15.8336 14.5172V12.8505H17.0836V14.5172H15.8336ZM15.8336 11.1839V9.51719H17.0836V11.1839H15.8336ZM15.8336 7.85053V6.18386H17.0836V7.85053H15.8336ZM15.8336 4.51719V3.26721C16.1774 3.26721 16.4716 3.38961 16.7164 3.6344C16.9612 3.87919 17.0836 4.17346 17.0836 4.51719H15.8336Z",
    fill: "#707070"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAreaProdutoImobiliario);
export default __webpack_public_path__ + "static/media/area-produto-imobiliario.e6345dbf2fa4528d1a2b4622e81153a9.svg";
export { ForwardRef as ReactComponent };